<div class="container-fluid h-100">
  <div class="d-flex h-100 w-100 align-items-center justify-content-center position-relative" *ngIf="isLoading" style="z-index: 1000000;">
    <div class="d-flex align-items-center justify-content-center rounded shadow p-4 bg-white">
      <i class="la la-spin la-cog la-2x ml-2"></i>
      <div class="ml-2">{{ "navigations.loading" | translate }}</div>
    </div>
  </div>

</div>
